export default __webpack_public_path__ + "static/media/175.bcb826d6.gif";